import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import { usePolicy } from 'dashboard/composables/usePolicy';

// Gestão do Técnico: acesso = módulo `field_service` ligado para a empresa (Super
// Admin, nasce desligado) E o usuário é de um papel base liberado para a conta
// (`field_service_roles`: administrator/agent) OU tem função personalizada com
// `field_service_module`. Usado no menu (Sidebar) e na própria tela.
export function useFieldServiceAccess() {
  const { currentAccount } = useAccount();
  const { checkPermissions } = usePolicy();

  const canAccessFieldService = computed(() => {
    const account = currentAccount.value;
    if (account?.feature_modules?.field_service !== true) return false;
    const roles = account?.field_service_roles ?? ['administrator', 'agent'];
    return (
      (roles.length > 0 && checkPermissions(roles)) ||
      checkPermissions(['field_service_module'])
    );
  });

  return { canAccessFieldService };
}
